import { RegistrationStepsNav } from 'app/components/shared/RegistrationStepsNav'
import { Base } from 'app/components/ui/Base'
import { BgRetina } from 'app/components/ui/BgRetina'
import { Button } from 'app/components/ui/Button'
import { Container } from 'app/components/ui/Container'
import { Text } from 'app/components/ui/Text'
import { useLayout } from 'app/contexts/LayoutProvider'
import { protectedRoutes } from 'app/routing/routes'
import { ScrollToTop } from 'app/routing/ScrollToTop'
import React, { useLayoutEffect } from 'react'
import styled from 'styled-components'

export const DocumentsRegistrationThanks = (): JSX.Element => {
  const { updateLayoutData } = useLayout()

  useLayoutEffect(() => {
    updateLayoutData({
      title: 'Area sponsor Marketing',
      subTitle:
        'Registrazione completata.\nSiamo felici e lavoreremo presto insieme!',
      headerVariant: 'authentication',
    })
  }, [updateLayoutData])

  return (
    <>
      <ScrollToTop />
      <Base>
        <Container>
          <RegistrationStepsNav
            currentStep={'thank_you'}
          ></RegistrationStepsNav>
        </Container>
      </Base>
      <Base paddingTop={0}>
        <BgRetina
          paddingTop={3}
          bgImage='https://res.cloudinary.com/estra/image/upload/v1629375626/estra20dev/sponsor/documents_upload/document_registration_thanks_bg.svg'
        >
          <ThanksContainer>
            <TextWrapper>
              <Text variant='s24' mb={3}>
                Ottime notizie! La parte più noiosa è finita e ora puoi andare a
                gestire le richieste dei sponsorizzazione che ci invierai
                direttamente in questo sistema.{'\n'}Se avrai necessità di
                aggiornare qualche dato o scaricare il PDF della tua anagrafica,
                puoi trovare tutto nel tuo profilo in tutte le pagine in alto a
                destra.
              </Text>
            </TextWrapper>
            <Button size='lg' to={protectedRoutes.dashboard.path}>
              CHIUDI E TORNA ALLA PAGINA PRINCIPALE
            </Button>
          </ThanksContainer>
        </BgRetina>
      </Base>
    </>
  )
}

const ThanksContainer = styled(Container)`
  text-align: center;
`

const TextWrapper = styled.div`
  max-width: 900px;

  margin-right: auto;
  margin-left: auto;
`
